module.exports = __webpack_public_path__ + "img/stop-blanco.3a4a3986.svg";